import { CircularProgress } from '@material-ui/core';
import React, { useContext } from 'react';
import LoadingContext from '../../contexts/LoadingContext';

const Loading: React.FC = () => {
  const {loading, loadingMessage} = useContext(LoadingContext);
  if(loading){
    return (
      <div className="loading-overlay">
        <div className="loading-content">
          <CircularProgress />
          {loadingMessage && <p>{loadingMessage}</p>}
        </div>
      </div>
    );
  }
  return <></>;
}

export default Loading;